const LINK_URL = `${window.location.origin}/profile`;

const LANG_MAP = {
  www: 'rus',
  kaz: 'kaz'
};

const PHONE_LAW_URL = `http://law.gov.kz/client/#!/doc/95699/${LANG_MAP[window.Site?.targeting?.section]}`;

const STORAGE_VALUE_TTL = 604800000; // 7 days in ms

const WIDGET_STEPS = {
  DEFAULT: 0,
  ALL: 1,
  PHONE: 2,
  NICKNAME: 3
};

const WIDGET_GROUP_B_STEPS = {
  NO_PHONE: 0,
  NO_NICKNAME: 1,
  PHONE: 2,
  NICKNAME: 3
};

export {
  LINK_URL,
  PHONE_LAW_URL,
  STORAGE_VALUE_TTL,
  WIDGET_STEPS,
  WIDGET_GROUP_B_STEPS
};
